import { Message } from 'element-ui';
import { handlePreview, updatePrintCount } from '@/modules/transport/otp/api/performancePrintTemplateConfig.js';
// 当前组件上下文
let componentContext = null;
/**
 * @description 判断待缓存数据是否为有效值
 */
export const isEmpty = (value) => {
    return value === null || value === undefined || value === '' || ['[]', '{}'].includes(JSON.stringify(value));
};

/**
 * @description 从本地存储读取数据
 */
export const getLocalStorage = (key) => {
    if (!key) return;
    return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : null;
};

/**
 * @description 写入数据到本地存储
 * @param {String} key 键名
 * @param {String|Object} value 键值
 */
export const setLocalStorage = (key, value) => {
    if (!key || isEmpty(value)) return;
    localStorage.setItem(key, JSON.stringify(value));
};

/**
 * @description 处理打印逻辑
 * @param {Object} ctx 当前组件上下文
 * @param {Object} params 打印参数
 */
export const handleDispatchPrint = (ctx, params) => {
    componentContext = ctx; // 保存当前组件上下文
    componentContext.btnLoading = true;
    handlePreview(params)
        .then(res => {
            if (res && +res.code === 0) {
                if (res.data && res.data.url) {
                    handleUpdatePrintCount(params, res.data);
                };
            }
        })
        .finally(() => {
            componentContext.btnLoading = false;
        });
};

/**
 * @description 更新打印次数
 * @param {Object} params 更新打印接口参数
 * @param {String} url 打印的链接
 */
const handleUpdatePrintCount = (params, data) => {
    const updateTimesParams = {
        dispatchNo: params.dispatchNo,
        templateCodeList: [params.templateCode]
    };
    return updatePrintCount(updateTimesParams).then(res => {
        if (res && +res.code === 0) {
            data.url && window.open(data.url);
        };
    });
};

/**
 * @description 打印校验
 * @param {Array} data 打印模板数据
 */
export const checkedDataValidated = data => {
    const checkedData = data.filter(v => v.checkedTemplate);
    if (!checkedData.length) {
        Message.warning('至少选择一个打印单');
        return false;
    }
    return true;
};
